import { createAsyncThunk } from '@reduxjs/toolkit';
import payrollServiceApiInstance from '../../../../../../config/payrollApiConfig';


// Create
export const createPfLoan = createAsyncThunk(
  'pfLoan/create',
  async (data: any, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      for (const key in data) {
        if (data[key] !== undefined && data[key] !== null) {
          if (key === 'attachment' && data[key] instanceof File) {
            formData.append('attachment', data[key], data[key].name);
          } else {
            formData.append(key, data[key]);
          }
        }
      }
      const res = await payrollServiceApiInstance.post('/pf-loan', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to create PF loan request');
    }
  }
);

// Get All
export const fetchAllPfLoans = createAsyncThunk(
  'pfLoan/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get('/pf-loan');
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch PF loan requests');
    }
  }
);

// Get By ID
export const fetchPfLoanById = createAsyncThunk(
  'pfLoan/fetchById',
  async (id: number, { rejectWithValue }) => {
    try {
      const res = await payrollServiceApiInstance.get(`/pf-loan/${id}`);
      return res.data;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to fetch PF loan request');
    }
  }
);

// Update
export const updatePfLoan = createAsyncThunk(
  'pfLoan/update',
  async ({ id, data }: { id: number; data: any }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      for (const key in data) {
        if (data[key] !== undefined && data[key] !== null) {
          if (key === 'attachment' && data[key] instanceof File) {
            formData.append('attachment', data[key], data[key].name);
          } else {
            formData.append(key, data[key]);
          }
        }
      }
      const res = await payrollServiceApiInstance.put(`/pf-loan/${id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return { id, data: res.data };
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to update PF loan request');
    }
  }
);

// Delete
export const deletePfLoan = createAsyncThunk(
  'pfLoan/delete',
  async (id: number, { rejectWithValue }) => {
    try {
      await payrollServiceApiInstance.delete(`/pf-loan/${id}`);
      return id;
    } catch (err: any) {
      return rejectWithValue(err.response?.data || 'Failed to delete PF loan request');
    }
  }
);
